import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SelectItem } from '../../widgets/SelectItem';
import { EntityForm } from '../../widgets/Forms';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
    },
    MuiSelectSelectMenu: {
        '& .MuiSelect-selectMenu': { paddingRight: "150px !important" }
    }
}));

function DGApplicationSearchForm(props) {
    const [labelWidth, setLabelWidth, tabValue] = React.useState(0);
    const labelRef = React.useRef(null);
    const classes = useStyles();
    const [FinancialYear, setFinancialYear] = React.useState(null);
    const [DGType, setDGType] = React.useState(null);



    const showDGIntervention = (FinancialYearID, DGTypeID) => {
        if (FinancialYearID != undefined) { setFinancialYear(FinancialYearID.Id) }
        if (DGTypeID != undefined) { setDGType(DGTypeID.Id) }
    }

    React.useEffect(() => {
        if (labelRef.current !== null) {
            setLabelWidth(labelRef.current.offsetWidth);
        }
    }, []);


    return (
        <EntityForm viewId="organisation" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={classes.container} >
                    <table cellPadding="2">
                        <tbody>
                            <tr>
                                <td>
                                    <SelectItem
                                        dataUrl="api/sims/dgapplication/GetDGFinancialYearLookupList"
                                        id="FinancialYearID"
                                        key={tabValue}
                                        label="Financial Year"
                                        required={true}
                                        form={form} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form >
            }
        </EntityForm>
    );
}

export default DGApplicationSearchForm;